export default function (key, newVal) {
  // 创建一个StorageEvent事件
  var newStorageEvent = document.createEvent('StorageEvent')
  const storage = {
    setItem (k, val) {
      localStorage.setItem(k, val)

      // 初始化创建的事件
      newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)

      // 派发对象
      window.dispatchEvent(newStorageEvent)

      newStorageEvent = null
    }
  }
  return storage.setItem(key, newVal)
}
